<template>
  <div class="page cr-detail-page">
    <div class="cr-detail">
      <div class="media-content" v-if="crData.length">
        <display
          :src="displayData.src"
          :type="displayData.type"
          :videoUrl="displayData.videoUrl"
          :objUrl="displayData.objUrl"
          :mtlUrl="displayData.mtlUrl">
        </display>

        <div class="flex-align-center">
          <div class="back-home-btn custom-button" @click="router.push('/home')">
            <img class="vector" src="@/assets/images/left.png" alt="">
            <span>返回首页</span>
          </div>
          <media-navigation :data-source="crData" @change="changeDisplayData"/>
        </div>
      </div>

      <div class="divider"></div>

      <div class="text-content">
        <div class="cr-name">{{ detailObj.chineseName }}</div>
        <ul>
          <li v-for="(item, index) in detailObj.attributeParams" :key="index">
            <span class="label">{{ item.attributeName }}</span>
            <span class="value">{{ item.value }}</span>
          </li>
        </ul>
      </div>
    </div>

    <div class="related-recommend">
      <div class="section-title">相关推荐</div>
      <van-list
        v-model:loading="loading"
        :finished="finished"
        finished-text="没有更多了"
        style=""
        @load="getRecommendList"
      >
        <cr-list :cr-list="dataList"/>
      </van-list>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { getCulturalRelic, listCulturalRelic } from '@/apis'

import Display from './components/Display'
import MediaNavigation from './components/MediaNavigation'
import CrList from '@/components/CrList/index'

const router = useRouter()
const route = useRoute()

const displayData = ref({
  src: '',
  type: undefined,
  objUrl: '',
  mtlUrl: '',
  videoUrl: ''
})
const crData = ref([])
const detailObj = ref({})

function changeDisplayData (data) {
  displayData.value = data
}

// function isJsonString (str) {
//   try {
//     const toObj = JSON.parse(str) // json字符串转对象
//     /*
//         判断条件 1. 排除null可能性
//                  2. 确保数据是对象或数组
//     */
//     if (toObj && typeof toObj === 'object') {
//       return true
//     }
//   } catch {
//   }
//   return false
// }
//
// function jsonValidate (value) {
//   return new Promise((resolve, reject) => {
//     if (value?.trim()) {
//       const isJson = isJsonString(value)
//       if (isJson) {
//         resolve(isJson)
//       }
//     }
//     reject(new Error('请输入正确的json字符串'))
//   })
// }

function getCulturalRelicDetail () {
  if (!route.params.id) {
    return
  }
  getCulturalRelic(route.params.id).then(res => {
    const resData = res.data
    detailObj.value = resData
    // 得到详情上面的文件展示
    const fileParams = resData.fileParams.map(item => item)

    const data = []
    fileParams.forEach((item, index) => {
      const type = item.type
      // 3d
      if (type === 1) {
        const obj = {
          type: 1,
          url: item.image
        }
        const urlArr = item.url.split(',')
        urlArr.forEach(item1 => {
          let suffix = item1.split('.')
          suffix = suffix[suffix.length - 1]
          if (suffix.toLocaleLowerCase() === 'mtl') {
            obj.mtlUrl = item1
          }
          if (suffix.toLocaleLowerCase() === 'obj') {
            obj.objUrl = item1
          }
        })
        data.push(obj)
      }
      // 图片
      if (type === 2) {
        const urlArr = item.url ? item.url.split(',').filter(i => i) : []
        urlArr.forEach(item => {
          const obj = { type: 2 }
          obj.src = item
          obj.url = item
          data.push(obj)
        })
      }
      // 视频
      if (type === 3) {
        const urlArr = JSON.parse(item.url)
        const obj = {
          type: 3,
          url: item.image
        }
        urlArr.forEach(item1 => {
          if (item1.isLowVideo) {
            obj.videoUrl = item1.url
            data.push(obj)
          }
        })
      }
    })
    crData.value = data
    if (crData.value.length) {
      displayData.value = crData.value[0]
    }
    // 获取相关推荐
    finished.value = false
    queryParams.value.categoryId = detailObj.value.categoryId
  })
  // const resData = {
  //   id: '5d2796f05235414ab6031095f7233575',
  //   chineseName: '观音白瓷',
  //   englishName: 'Guanyin White Porcelain',
  //   headImage: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/163963971186969291631-bf47-4999-b413-6be28e6b15b0.png',
  //   isBanner: false,
  //   recommendImage: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/16396397119086c1471c6-b0f6-4a2e-aa24-84ed4573af50.png',
  //   hotRecommend: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1639639711939972c5123-209b-4685-b107-c3d22223952f.png',
  //   categoryId: '44008a98170f4584b7a72674c50f514d',
  //   categoryName: '陶瓷',
  //   organizationId: 'aac252de37c1463799df4acb682040d5',
  //   organizationName: '湖南省博物馆',
  //   organizationUrL: null,
  //   introduction: '观音白瓷',
  //   knowledgeMap: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1639639711981ddeaebb6-3977-4508-8fcf-ddc5b0d06dc7.png',
  //   baseWatch: 56,
  //   baseCollect: 6,
  //   usageScebarios: '[]',
  //   explain: '免费',
  //   correlation: '[]',
  //   attributeParams: null,
  //   fileParams: [{ id: null, culturalRelicId: null, type: 1, name: '观音白瓷', charge: 1, price: null, url: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1639644700955观音白瓷.obj', image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/16396447008582f9be3eb-5880-432d-81f7-3ad46b052968.png' }, { id: null, culturalRelicId: null, type: 2, name: '观音白瓷', charge: 1, price: null, url: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1639644700725b492ff28-cc30-434d-a653-4273e890bdfe.png', image: '' }],
  //   status: null,
  //   allWatch: null,
  //   allCollect: null,
  //   isCollect: false,
  //   value: null,
  //   keywords: null,
  //   properties: [
  //     { label: '创作时间', value: '明' },
  //     { label: '风格', value: '明式家具' },
  //     {
  //       label: '计量',
  //       value: '长： 68.5CM；\n' +
  //         '宽：47CM；\n' +
  //         '高：119.5CM'
  //     },
  //     { label: '外观描述', value: '官帽椅,为硬木家具,属于扶手椅的一种,是外来扶手靠背椅逐渐汉化的产物,定型于宋代。因其搭脑形似古代官员所戴的官帽而得名。它主要是供官员待客和学子读书所用的座椅。本案例官帽椅为17世纪制作的黄花梨四出头官帽椅,框架部分用黄花梨木榫接而成,座面部分则用藤条编织而成。' }
  //   ]
  // }
}

watch(() => route.fullPath, () => {
  displayData.value = {
    src: '',
    type: undefined,
    objUrl: '',
    mtlUrl: '',
    videoUrl: ''
  }
  getCulturalRelicDetail()
}, { immediate: true })

onMounted(() => {
  // console.log(route.fullPath)
  // getCulturalRelicDetail()
})

// 相关推荐
const finished = ref(true)
const loading = ref(false)
const dataList = ref([])

const queryParams = ref({})

function resetQueryParams () {
  queryParams.value = {
    categoryId: '',
    page: 1,
    pageSize: 12
  }
}

resetQueryParams()

function getRecommendList () {
  listCulturalRelic(queryParams.value).then(res => {
    const data = res.data?.map(item => {
      item = {
        ...item,
        properties: []
      }
      item.type && item.properties.push(item.type)
      item.period && item.properties.push(item.period)
      return item
    })

    if (!data || data.length <= 0) {
      finished.value = true
      return
    }

    dataList.value = dataList.value.concat(data)
    queryParams.value.page += 1
    loading.value = false

    if (data.length < queryParams.value.pageSize) {
      finished.value = true
    }
  })
}
</script>

<style lang="scss" scoped>
.cr-detail-page {
  padding: 90px 69px 102px;
}

.cr-detail {
  display: flex;
  align-items: center;
}

.media-content {
  flex: 1;

  .back-home-btn {
    font-size: 20px;
    font-weight: 600;
    font-family: 'NotoSerifSC', system-ui;

    .vector {
      margin-right: 10px;
    }
  }

  .media-navigation {
    flex: 1;
  }
}

.divider {
  flex-shrink: 0;
  width: 1px;
  height: 566px;
  background-image: url("~@/assets/images/detail-divider.png");
  background-position: center;
  background-repeat: no-repeat;
  margin-right: 40px;
}

.text-content {
  flex-shrink: 0;
  width: 441px;
  height: 766px;
  font-family: 'NotoSerifSC', system-ui;
  overflow-y: auto;

  &::-webkit-scrollbar {
    display: none;
  }

  .cr-name {
    font-size: 32px;
    font-weight: 600;
    line-height: 46px;
    margin-bottom: 122px;
  }

  ul {
    padding-left: 40px;
  }

  li {
    margin-bottom: 58px;
    display: flex;
    flex-direction: column;

    .label {
      font-size: 20px;
      font-weight: 700;
      line-height: 29px;
      margin-bottom: 15px;
    }

    .value {
      font-size: 20px;
      font-weight: 300;
      line-height: 29px;
    }
  }
}

.related-recommend {
  .section-title {
    font-size: 24px;
    font-weight: 700;
    text-align: center;
    font-family: 'NotoSerifSC', system-ui;
    margin: 133px 0 58px;
  }
}
</style>
